import { render, staticRenderFns } from "./transferCommon.pug?vue&type=template&id=6c369f99&scoped=true&lang=pug&"
import script from "./transferCommon.ts?vue&type=script&lang=ts&"
export * from "./transferCommon.ts?vue&type=script&lang=ts&"
import style0 from "./transferCommon.styl?vue&type=style&index=0&id=6c369f99&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c369f99",
  null
  
)

export default component.exports